"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { Box } from "@chakra-ui/react";
import Select from "react-select";
import { OptionComponent, ControlComponent } from "../../atoms/Select/Select";
import { getStyles } from "../../atoms/Select/Select.styles";
import { InputVariant } from "../../atoms/Input/Input.types";
const SearchInput = (_a) => {
    var { name, defaultValue, options, isDisabled = false, mandatory = false } = _a, rest = __rest(_a, ["name", "defaultValue", "options", "isDisabled", "mandatory"]);
    const dropdownStyle = getStyles(rest.variant, true);
    const selectRef = useRef(null);
    return (_jsx(Box, Object.assign({ sx: dropdownStyle }, { children: _jsx(Select, Object.assign({ ref: selectRef, defaultValue: defaultValue, classNamePrefix: "pluxee-select", components: {
                Control: ControlComponent,
                IndicatorSeparator: null,
                DropdownIndicator: null,
                Option: OptionComponent,
            }, isSearchInput: true, name: name, options: options, isDisabled: isDisabled || rest.variant === InputVariant.READONLY, openMenuOnFocus: true, searchInputClearCallback: () => {
                var _a, _b;
                (_a = selectRef.current) === null || _a === void 0 ? void 0 : _a.blur();
                (_b = selectRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }, required: mandatory }, rest)) })));
};
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map